"use client"

import Link from "next/link"
import Image from "next/image"
import { Button } from "@/components/ui/button"
import { useAigency } from "@/components/aigency-modal/AigencyContext"
import { 
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card"

interface TeamMemberProps {
  imageSrc: string
  name: string
  displayName?: string
  linkedinUrl: string
  twitterUrl?: string
  emailDestination?: string
}

export function TeamMember({ imageSrc, name, displayName, linkedinUrl, twitterUrl, emailDestination }: TeamMemberProps) {
  const { openConversation } = useAigency()
  // Use displayName if provided, otherwise use the first part of the name
  const nameToDisplay = displayName || name.split(" ")[0]

  // Handle click to open modal for team members
  const handleClick = () => {
    if (name === "Matt Scobel") {
      openConversation({
        _id: `team-${name}`,
        name,
        displayName,
        role: "Co-Founder",
        calendlyUrl: "scobel/30min",
        linkedinUrl,
        twitterUrl,
        imageSrc
      }, 'human')
    } else if (name === "Khurram Ahmad") {
      openConversation({
        _id: `team-${name}`,
        name,
        displayName,
        role: "Co-Founder",
        calendlyUrl: "trpc-book/30min",
        linkedinUrl,
        twitterUrl,
        imageSrc,
        emailDestination
      }, 'human')
    }
  }

  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <div 
          className="cursor-pointer"
          onClick={handleClick}>
          <div className="w-8 h-8 rounded-full overflow-hidden ring-2 ring-border hover:ring-primary transition-all">
            <Image
              src={imageSrc || "/placeholder.svg"}
              alt={name}
              width={32}
              height={32}
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </HoverCardTrigger>
      <HoverCardContent className="w-auto p-4" side="top">
        <div className="flex flex-col items-center space-y-3">
          <div className="text-center">
            <p className="text-sm font-medium">{nameToDisplay}</p>
          </div>
          <div className="flex items-center gap-2">
            <Link href={linkedinUrl} target="_blank" rel="noopener noreferrer">
              <Button variant="ghost" size="icon" className="h-8 w-8">
                <Image src="/icons/linkedin.svg" alt="LinkedIn" width={16} height={16} className="h-4 w-4 dark:invert" />
                <span className="sr-only">LinkedIn</span>
              </Button>
            </Link>
            {twitterUrl && (
              <Link href={twitterUrl} target="_blank" rel="noopener noreferrer">
                <Button variant="ghost" size="icon" className="h-8 w-8">
                  <Image src="/icons/x.svg" alt="X" width={16} height={16} className="h-4 w-4 dark:invert" />
                  <span className="sr-only">X</span>
                </Button>
              </Link>
            )}
          </div>
        </div>
      </HoverCardContent>
    </HoverCard>
  )
}
